export default __webpack_public_path__ + "./images/lc.c165bbcb.png";